module.exports = __webpack_public_path__ + "static/pareto_constats-2eeaa9a09b3424541086d961c73f3569.png";